// src/pages/GuessWhatGame.jsx
import React, { useState, useMemo } from 'react';
import './GuessWhatGame.css';
import bigReveal from '../assets/bulgogifries.png'; // <-- replace with your image

// Tweak these to your content
const CLUES = [
  'freshman year vibes',
  "you can pay for them with your meal plan",
  'no longer on the menu',
  'turn your lips kind of orange',
  'spicy',
  'must be eaten with a fork and many many napkins',
  "you wait in a long line for them after class",
  "squirrels try to steal them"
];

// Accept multiple spellings
const ACCEPTED_ANSWERS = [
  'bulgogi fries', 'GBC bulgogi fries', 'gbc bulgogi fries', 'GBC Bulgogi Fries', 'Bulgogi Fries', 'Bulgogi fries', 'GBC'
  // add more variants if needed
].map(a => a.toLowerCase());

export default function GuessWhatGame() {
  const [shown, setShown] = useState(1);          // how many clues are visible
  const [value, setValue] = useState('');         // input box
  const [status, setStatus] = useState('idle');   // 'idle' | 'wrong' | 'right'
  const [overlay, setOverlay] = useState(false);  // reveal image

  const atEnd = useMemo(() => shown >= CLUES.length, [shown]);

  const submit = (e) => {
    e.preventDefault();
    const guess = value.trim().toLowerCase();
    if (!guess) return;

    if (ACCEPTED_ANSWERS.includes(guess)) {
      setStatus('right');
      setOverlay(true);
    } else {
      setStatus('wrong');
    }
  };

  const nextClue = () => {
    if (!atEnd) setShown(s => s + 1);
  };

  const reset = () => {
    setShown(1);
    setValue('');
    setStatus('idle');
    setOverlay(false);
  };

  return (
    <div className="gwg-wrap">
      <div className="gwg-card" role="region" aria-label="Guessing game">
        <h1 className="gwg-title">guess what game</h1>

        {/* Text box + submit */}
        <form className="gwg-form" onSubmit={submit}>
          <label htmlFor="answer" className="sr-only">Type your answer</label>
          <input
            id="answer"
            className="gwg-input"
            placeholder="Type your answer here"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoComplete="off"
          />
          <button className="gwg-submit" type="submit">Submit</button>
        </form>

        {/* Snarky line on wrong */}
        {status === 'wrong' && (
          <p className="gwg-wrong" role="alert">WRONGO! dumbass</p>
        )}

        {/* Clues */}
        <div className="gwg-clues">
          {CLUES.slice(0, shown).map((text, i) => (
            <p className="gwg-clue" key={i}>
              {i + 1}. {text}
            </p>
          ))}
        </div>

        {/* Controls */}
        <div className="gwg-actions">
          <button
            className="gwg-next"
            onClick={nextClue}
            disabled={atEnd || status === 'right'}
            aria-disabled={atEnd || status === 'right'}
          >
            Next clue
          </button>

          {status === 'right' && (
            <button className="gwg-reset" onClick={reset}>Play again</button>
          )}
        </div>
      </div>

      {/* Full-screen overlay on correct */}
      {overlay && (
        <div className="gwg-overlay" role="dialog" aria-modal="true">
          <button
            className="gwg-close"
            aria-label="Close image"
            onClick={() => setOverlay(false)}
          >
            ×
          </button>
          <img src={bigReveal} alt="You got it!" className="gwg-reveal" />
        </div>
      )}
    </div>
  );
}